<template>
  <div v-cloak id="order-payments">
    <div class="vx-row mb-4">
      <div class="vx-col w-full mb-2">
        <vs-button
          @click="createCashPayment()"
          class="bg_l_green"
          v-has-permission="'CreateCashBankPayment'"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("AddCashPayment") }}
        </vs-button>
      </div>
    </div>
    <div class="vx-card">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="custom-tbl">
            <vs-table
              :data="orderPayments"
              ref="table"
              id="order-payments-tbl"
              v-if="refresh"
            >
              <template slot="thead">
                <vs-th>{{ $t("#") }}</vs-th>
                <vs-th>{{ $t("SiteOrderNumber") }}</vs-th>
                <vs-th>{{ $t("DraftOrderId") }}</vs-th>
                <vs-th>{{ $t("PaymentAmount") }}</vs-th>
                <vs-th>{{ $t("SumOfPaymentsAmount") }}</vs-th>
                <vs-th>{{ $t("ReferenceId") }}</vs-th>
                <vs-th>{{ $t("BankType") }}</vs-th>
                <vs-th>{{ $t("BankStatus") }}</vs-th>
                <vs-th>{{ $t("PaymentType") }}</vs-th>
                <vs-th>{{ $t("Status") }}</vs-th>
                <vs-th>{{ $t("PaymentId") }}</vs-th>
                <vs-th>{{ $t("Description") }}</vs-th>
                <vs-th>{{ $t("CreateOn") }}</vs-th>
                <vs-th>{{ $t("Action") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr]">
                    {{ parseInt(indextr) + 1 }}
                  </vs-td>
                  <vs-td :data="data[indextr].basketInfo.basketId">
                    {{ data[indextr].basketInfo.basketId }}
                  </vs-td>
                  <vs-td :data="data[indextr].basketInfo.draftOrderId">
                    <span v-if="data[indextr].basketInfo.draftOrderId">{{
                      data[indextr].basketInfo.draftOrderId
                    }}</span>
                    <span v-if="!data[indextr].basketInfo.draftOrderId">-</span>
                  </vs-td>
                  <vs-td :data="data[indextr].amount">
                    {{ Number(data[indextr].amount).toLocaleString() }} ریال
                  </vs-td>
                  <vs-td :data="data[indextr].sumOfPaymentsAmount">
                    {{
                      Number(data[indextr].sumOfPaymentsAmount).toLocaleString()
                    }}
                    ریال
                  </vs-td>
                  <vs-td :data="data[indextr].referenceId">
                    <span v-if="data[indextr].referenceId == null">-</span>
                    {{ data[indextr].referenceId }}
                  </vs-td>
                  <vs-td :data="data[indextr].bankType">
                    <span v-if="data[indextr].bankType == 1">ملت</span>
                    <span v-if="data[indextr].bankType == 2">ملی</span>
                    <span v-if="data[indextr].bankType == 3">مسکن</span>
                    <span v-if="data[indextr].bankType == 4">سپه</span>
                    <span v-if="data[indextr].bankType == 5">پاسارگاد</span>
                    <span v-if="data[indextr].bankType == 6">پارسیان</span>
                    <span v-if="data[indextr].bankType == 7">ایران خودرو</span>
                  </vs-td>
                  <vs-td :data="data[indextr].bankStatus">
                    {{ data[indextr].bankStatus }}
                  </vs-td>
                  <vs-td :data="data[indextr].paymentType">
                    <span v-if="data[indextr].paymentType == 1">{{
                      $t("Online")
                    }}</span>
                    <span v-if="data[indextr].paymentType == 2">{{
                      $t("Cash")
                    }}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].state">
                    <span v-if="data[indextr].state == 1">{{
                      $t("Create")
                    }}</span>
                    <span v-if="data[indextr].state == 2">{{
                      $t("Token")
                    }}</span>
                    <span v-if="data[indextr].state == 3">{{
                      $t("CallBackFromBank")
                    }}</span>
                    <span v-if="data[indextr].state == 4">{{
                      $t("Confirm")
                    }}</span>
                    <span v-if="data[indextr].state == 5">{{
                      $t("Reject")
                    }}</span>
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].id }}
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>
                  <vs-td :data="data[indextr].createOn">
                    {{ data[indextr].createOn }}
                  </vs-td>
                  <vs-td :data="data[indextr].createOn">
                    <div
                      class="w-full h-full flex gap-2 justify-center items-center flex-wrap"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        class="view-btn shrink-0"
                        @click.prevent="paymentConfirmation(data[indextr])"
                        v-has-permission="'ConfrimBankPayment'"
                        >تایید پرداخت</vs-button
                      >
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="shrink-0 d-inline"
                        v-has-permission="'ModifyCashBankPayment'"
                        @click.prevent="editPayment(data[indextr])"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
    <order-payment-popup
      :show="ModifyPopup"
      :model="modalModel"
      @close="closeModifyPopup"
      @finish="onfinish"
    ></order-payment-popup>
  </div>
</template>
<style lang="scss">
#order-payments-tbl td,
#order-payments-tbl td {
  font-size: 0.925rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import OrderPaymentPopup from "./OrderPaymentPopup.vue";
export default {
  name: "basketManagement_WebSiteBaskets_OrderPayments",

  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      id: null,
      refresh: true,
    };
  },
  computed: {
    ...mapGetters({
      orderPayments: "bankPayments/list",
    }),
  },
  mounted() {
    this.id = this.$route.params.id;
    this.load();
  },
  methods: {
    ...mapActions({
      fetchOrderPayments: "bankPayments/fetchOrderPayments",
      addPaymentConfirmation: "bankPayments/addPaymentConfirmation",
    }),
    load() {
      this.fetchOrderPayments(this.id);
    },
    createCashPayment() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    editPayment(model) {
      this.modalModel = {
        id: model.id,
        basketId: model.basketInfo.basketId,
        amount: model.amount,
        saleInterface: model.saleInterface,
        bankType: model.bankType,
        referenceId: model.referenceId,
        description: model.description,
        paymentAttachmentImageContent: model.paymentAttachmentQuery,
        paymentType: model.paymentType,
      };
      this.ModifyPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    paymentConfirmation(rowDetail) {
      this.addPaymentConfirmation(rowDetail).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "پرداخت سفارش مورد نظر تایید شد",
          showConfirmButton: false,
          timer: 2000,
        });
      });
    },
    onfinish() {
      this.refresh = false;
      this.closeModifyPopup();
      this.fetchOrderPayments(this.id).then(() => {
        this.refresh = true;
      });
    },
  },
  components: {
    OrderPaymentPopup,
  },
};
</script>
